/* Copyright 2023 (Unpublished) Verto Inc. */

// Angular
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Router } from '@angular/router';

// rxjs
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, throttleTime } from 'rxjs/operators';

// Services
import { CurrentUserService } from '../services/root-services/current-user.service';
import { MessageService } from 'primeng/api';

@Injectable()
export class IdentityInterceptor implements HttpInterceptor {
  private _notAuthenticated$ = new Subject();

  constructor(
    private currentUserService: CurrentUserService,
    private router: Router,
    private _messageService: MessageService
  ) {
    this._notAuthenticated$.pipe(throttleTime(500)).subscribe(() => {
      this._messageService.add({
        severity: 'error',
        summary: 'Session expired',
        detail: 'Your current session has expired. Please login again.',
      });
    });
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const { token } = this.currentUserService;

    // if logged-in
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }

    // pass on request
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.currentUserService.logout();
          // Set the current URL to redirect to after login
          this.router.navigate(['/login'], {
            queryParams: { redirect: this.router.url },
          });

          this._notAuthenticated$.next();
        }

        return throwError(error);
      })
    );
  }
}
